// src/data/pathCharacters.js
//
// The little figure that travels the Guided Path on a member's dashboard.
// Which one an org gets is a setting — organizations/{id}.pathCharacter —
// chosen in the super-admin Organization editor. A hockey body gets a skater;
// the default stays the dog sled.
//
// Ids persist to Firestore, so add new ones freely but never rename one. The
// artwork for each id lives in components/dashboard/PathCharacters.jsx; this
// file is plain data so the admin editor can list the options without pulling
// in SVG components.

export const DEFAULT_PATH_CHARACTER = 'dogsled';

export const PATH_CHARACTER_OPTIONS = [
    { id: 'dogsled', label: 'Dog sled (default)' },
    { id: 'hockey', label: 'Hockey player' }
];

// Always resolves to a character that exists, so an org doc carrying an id
// from a newer build, or a typo, still draws something.
export const resolvePathCharacter = (org) =>
    (PATH_CHARACTER_OPTIONS.some((c) => c.id === org?.pathCharacter) ? org.pathCharacter : DEFAULT_PATH_CHARACTER);
